/**
 * The .NET products, in one React-free list, so that the manifest, the pages
 * and the server agree.
 */

/** The .NET tools bundles. */
export const DOT_NET_TOOLS_PRODUCTS: readonly string[] = ["DNT", "DU", "DN"];

/** The products whose Releases splash is the .NET splash (DotNetSplash), not Splash. */
export const DOT_NET_RELEASE_PRODUCTS: readonly string[] = [
  ...DOT_NET_TOOLS_PRODUCTS,
  "DC",
  "DM",
  "DT",
  "DP",
  "RS",
  "RScpp",
];
